(() => {
  if (window.MBSGift) return;
  const config = window.MBSGiftConfig;
  if (!config?.variantId || !config.eligibleIds?.length) return;
  const root = window.Shopify?.routes?.root || '/';
  const originalFetch = window.fetch.bind(window);
  const eligibleIds = new Set(config.eligibleIds.map(String));
  let pending, timer;
  const isGift = item => String(item.variant_id || item.id) === String(config.variantId);
  const sections = () => document.querySelector('cart-drawer')?.getSectionsToRender?.().map(item => item.section) || ['cart-drawer','cart-counter'];
  const refresh = data => {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && sections().every(id => data?.sections?.[id])) {
      try {drawer.renderContents(data,drawer.classList.contains('is-visible'));} catch (_) {}
    }
    document.dispatchEvent(new CustomEvent('mbs:gift-synced',{detail:data}));
  };
  async function getCart() {
    const response = await originalFetch(`${root}cart.js`,{credentials:'same-origin'});
    if (!response.ok) throw new Error('Cart unavailable');
    return response.json();
  }
  async function mutate(path,body) {
    body.sections=sections();body.sections_url=location.pathname;
    const response=await originalFetch(`${root}cart/${path}.js`,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)});
    if (!response.ok) return null;
    return response.json();
  }
  async function runSync() {
    const cart=await getCart();
    const eligible=cart.items.some(item=>eligibleIds.has(String(item.product_id)));
    const automatic=cart.items.filter(item=>isGift(item)&&item.properties?._MBS_GIFT);
    let result=null;
    if (eligible && config.available && !cart.items.some(isGift)) {
      result=await mutate('add',{items:[{id:config.variantId,quantity:1,properties:{_MBS_GIFT:'Armband cadeau bij comfort set'}}]});
      // Shopify applies the real automatic discount. Never leave a paid "gift" in the cart.
      if (result) {
        const checked=await getCart();
        const added=checked.items.find(item=>isGift(item)&&item.properties?._MBS_GIFT);
        if (added && added.final_line_price > 0) result=await mutate('change',{id:added.key,quantity:0});
      }
    } else if (!eligible && automatic.length) {
      for (const item of automatic) result=await mutate('change',{id:item.key,quantity:0});
    } else if (eligible && automatic.some(item=>item.quantity!==1 || item.final_line_price>0)) {
      for (const item of automatic) result=await mutate('change',{id:item.key,quantity:item.final_line_price>0?0:1});
    }
    if (result) refresh(result);
    return result;
  }
  function sync() {
    if (!pending) pending=runSync().catch(()=>null).finally(()=>{pending=null;});
    return pending;
  }
  window.MBSGift={sync};
  function schedule() {clearTimeout(timer);timer=setTimeout(sync,250);}
  window.fetch=(...args)=>originalFetch(...args).then(response=>{
    const url=typeof args[0]==='string'?args[0]:args[0]?.url || '';
    if (response.ok && /\/cart\/(add|change|update)(\.js)?(?:\?|$)/.test(url)) schedule();
    return response;
  });
  document.addEventListener('submit',event=>{
    if (event.target?.matches('form[action*="/cart/add"]')) schedule();
  },true);
  sync();
})();
